import { grayColor } from "assets/jss/material-dashboard-pro-react.js";

const cardFooterStyle = {
  cardFooter: {
    padding: "0",
    paddingTop: "10px",
    margin: "0 15px 10px",
    borderRadius: "0",
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
    backgroundColor: "transparent",
    border: "0",
  
    "@media (max-width: 1200px)": {
      margin: "0 12px 8px",
    },
  
    "@media (max-width: 960px)": {
      margin: "0 10px 8px",
      flexWrap: "wrap",
      gap: "8px",
    },
  
    "@media (max-width: 600px)": {
      margin: "0 8px 6px",
      paddingTop: "8px",
    },
  },
  cardFooterProfile: {
    marginTop: "-15px",
  
    "@media (max-width: 960px)": {
      marginTop: "-8px",
    },
  
    "@media (max-width: 600px)": {
      marginTop: "0",
    },
  },
  cardFooterStats: {
    borderTop: "1px solid" + grayColor[8],
    marginTop: "20px",
  
    "@media (max-width: 960px)": {
      marginTop: "15px",
      paddingTop: "8px",
    },
  
    "@media (max-width: 600px)": {
      marginTop: "10px",
    },
  
    "& svg": {
      position: "relative",
      top: "4px",
      marginRight: "3px",
      marginLeft: "3px",
      width: "16px",
      height: "16px",
  
      "@media (max-width: 600px)": {
        width: "14px",
        height: "14px",
      },
    },
  
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      top: "4px",
      marginRight: "3px",
      marginLeft: "3px",
      fontSize: "16px",
      lineHeight: "16px",
  
      "@media (max-width: 600px)": {
        fontSize: "14px",
        lineHeight: "14px",
      },
    },
  },
  cardFooterPricing: {
    zIndex: "2",
  },
  cardFooterTestimonial: {
    display: "block",
  
    "@media (max-width: 960px)": {
      textAlign: "center",
    },
  },
  cardFooterChart: {
    borderTop: "1px solid" + grayColor[8],
  },
};

export default cardFooterStyle;
